import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00045FunctionFinish } from './P00045/Installation/P00045InstallationFinish';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P00045FunctionReset } from './P00045/Installation/P00045InstallationReset';
import { Pool, PoolAdditionalData } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00045MiseEnOeuvreInit } from './P00045/Link/miseenoeuvre/P00045MiseEnOeuvreInit';
import { P00045CardLinkStatusComponent } from './P00045/Link/cards/p00045-card-link-status/p00045-card-link-status.component';
import { P00045CardLinkControleComponent } from './P00045/Link/cards/p00045-card-link-controle/p00045-card-link-controle.component';
import { P00045InstallationFuseauHoraireComponent } from './P00045/Installation/p00045-installation-fuseau-horaire/p00045-installation-fuseau-horaire.component';
import { P00045InstallationParametrageConnexionComponent } from './P00045/Installation/p00045-installation-parametrage-connexion/p00045-installation-parametrage-connexion.component';
import { P00045InstallationParametrageConnexionWIFIComponent } from './P00045/Installation/p00045-installation-parametrage-connexion-wifi/p00045-installation-parametrage-connexion-wifi.component';
import { P00045InstallationParametrageCheckWIFIComponent } from './P00045/Installation/p00045-installation-parametrage-check-wifi/p00045-installation-parametrage-check-wifi.component';
import { P00045LinkStatusComponent } from './P00045/Link/cps/p00045-link-status/p00045-link-status.component';
import { P00032Alarm } from './P00032/Alarm/P00032Alarm';
import { P00045Alarm } from './P00045/Alarm/P00045Alarm';

export class P00045Data {
  cnSClientConnecte: number = 0;

  cnSEtatConnexionHTTPS: number = 0;

  cnSEtatConnexionMQTT: number = 0;

  cnSEtatConnexionEthernet: number = 0;

  cnSEtatConnexionWifi: number = 0;

  cnSEtatProcessusWifi: number = 0;

  cnSEtatPurgeHistorique: number = 0;

  cnSAlarme: number = 0;

  cnSRSSIWifi: number = 0;

  cnSDebutPurge: string = '00/00/0000 00:00';

  cnSFinPurge: string = '00/00/0000 00:00';

  cnSCompteurResetUsine: number = 0;

  cnIMotDePasseWifi: string = '';

  cnINomWifi: string = '';

  cnIMiseAJourAutomatiqueProduits: number = 0;

  cnIResetUsine: number = 0;

  cnIConfigurationProduit: number = 0;

  cnIConfirmationOTA: number = 0;

  cnSCompteurPowerCycle: number = 0;

  cnSCompteurResetTacheACWA: number = 0;

  cnSCompteurResetTacheZ3: number = 0;

  cnSMaximumJournalierEspaceFlashUtilise: number = 0;

  cnSCompteurAccessFichier: number = 0;

  cnSCompteurErreurAccessFichier: number = 0;

  cnSCompteurAPIPThread: number = 0;

  cnSCompteurErreurAPIPThread: number = 0;

  cnSMaximumJournalierRAMUtilise: number = 0;

  cnSCompteurPublishMQTT: number = 0;

  cnSCompteurErreurPublishMQTT: number = 0;

  cnSCompteurRequetesHTTP: number = 0;

  cnSCompteurErreursCURL: number = 0;

  cnSCompteurErreursHTTP: number = 0;

  cnSCompteurReportsZigbee: number = 0;

  cnSCompteurErreurReportZigbee: number = 0;

  cnITimezone: string = '';
}

export class P00045 extends IProduct {
  override deviceTableIndex: number = 24;

  override dataIdentifier?: string = 'connect';

  override modelIdentifier?: string = 'P00045';

  override manufacturerName?: string = 'ACWA';

  data: P00045Data = new P00045Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00045/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00045/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00045/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00045;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.connect?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00045.tuto.installation.help.title',
      helpSlides: [
        'P00045.tuto.installation.help.1',
        'P00045.tuto.installation.help.2',
        'P00045.tuto.installation.help.3',
        'P00045.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00045/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00045/installation-1_dark.png',
          },
          text: 'P00045.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00045/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00045/installation-2_dark.png',
          },
          text: 'P00045.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00045InstallationFuseauHoraireComponent,
            condition: (pool) => {
              return pool.deviceTable.master.firmwareVersion >= 5;
            },
          },
          {
            component: P00045InstallationParametrageConnexionComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00045InstallationParametrageConnexionWIFIComponent,
            condition: (pool, poolAditionalData: PoolAdditionalData) => {
              return poolAditionalData.networkConnexion === 1;
            },
          },
          {
            component: P00045InstallationParametrageCheckWIFIComponent,
            condition: (pool, poolAditionalData: PoolAdditionalData) => {
              return true;
            },
          },
        ],
        finish: P00045FunctionFinish,
        reset: P00045FunctionReset,
      },

      controlCards: [],

      statusCards: [{ component: P00045CardLinkStatusComponent, weight: 24 }],

      alarms: {
        weight: 30,
        component: P00045Alarm,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.CONNECTIVITY];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.LINK ||
      functionnality == EventProductFunctionnalityEnum.CONNECTIVITY
    ) {
      return {
        miseEnOeuvre: {
          pages: [],
          init: P00045MiseEnOeuvreInit,
        },

        controle: {
          enabledUser: false,
          enabledSupport: false,
          component: null,
        },
        parametrages: {
          enabledUser: false,
          enabledSupport: false,

          reglage: {
            enabledUser: false,
            enabledSupport: false,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00045LinkStatusComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00045.parameters.historique.suivi.connnexionCable',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 411,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'cnSEtatConnexionEthernet',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P00045.parameters.historique.suivi.connnexionWifi',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 412,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'cnSEtatConnexionWifi',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Connect_Installation3,
      propertyName: 'cnIConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return null;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).cnIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
